import clsx from 'clsx';
import {
  Monitor,
  Server,
  Wifi,
  Network,
  Radio,
  Video,
  Cpu,
  Fingerprint,
  DoorOpen,
  Box,
  Tablet,
  Smartphone
} from 'lucide-react';
import { hostOsIconSrc } from './Hosts/HostOsIcon';

/**
 * Ícone do dispositivo: custom (base64) → ficheiro do tipo (ex. proxmox.png) → Lucide por kind.
 */
const DeviceKindIcon = ({
  kind,
  iconFileName,
  kindIconFileName,
  customIconBase64,
  size = 16,
  className = '',
  title: titleProp,
}) => {
  const fileName = kindIconFileName ?? iconFileName;
  const rasterSrc = customIconBase64
    ? customIconBase64
    : fileName
      ? hostOsIconSrc(fileName)
      : null;

  if (rasterSrc) {
    const title = titleProp ?? kind;
    return (
      <img
        src={rasterSrc}
        alt=""
        width={size}
        height={size}
        className={clsx(
          'shrink-0',
          customIconBase64 ? 'rounded-md object-cover' : 'object-contain',
          className
        )}
        loading="lazy"
        decoding="async"
        title={title}
        {...(title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true })}
      />
    );
  }

  const iconMap = {
    LinuxUbuntu: Server,
    LinuxDebian: Server,
    LinuxCentOS: Server,
    LinuxFedora: Server,
    WindowsServer: Monitor,
    AndroidDevice: Monitor,
    AndroidTablet: Tablet,
    AndroidPhone: Smartphone,
    MikrotikRouter: Wifi,
    IOGoOne: Wifi,
    MikrotikSwitch: Network,
    MikrotikAccessPoint: Radio,
    IpCamera: Video,
    PlcController: Cpu,
    BiometricReader: Fingerprint,
    AccessControl: DoorOpen,
  };

  const IconComponent = iconMap[kind] || Box;

  return (
    <IconComponent
      size={size}
      className={className}
      title={titleProp ?? kind}
    />
  );
};

export default DeviceKindIcon;
